import create from '@ant-design/icons/lib/components/IconFont';
import { getEnvValue } from './Environment';
import { include, reverse } from 'named-urls';
const endpoint = {
  auth: include('/api', {
    login: 'login',
  }),
  organization:include('/api/organization/:id',{
    userCreate:'user/create',
    users:'users',
    invitation:'invitations',
    candidate:'candidates',
    candidatebyId:'candidate/:candidateId',
    invitationCreate:'invitation/create',
    openLinkCreate:'openlink/create',
    openLinkInvitationotp:'openlink/invitation/otp',
    logo:'logo',
    question:include('question',{
      self:'',
      create:'create',
      id:':quesId'
    }),
    test:include('test',{
      self:'',
      create:'create',
      id:':testId',
      update:'update/:testId',
      delete:'delete/:testId',
      
    }),
  }),
  globalApi:include('/api',{
    technology:'technologies',
    keyskill:'keyskills'
  }),
  candidate:include('/api/candidate',{
    login:'login',
    create:'create',
    candidatebyemail:"candidatebyemail",
    getCandidateTest:':candidateId/get-candidate-test',
    test:include('test',{
      self:'',
      details:'details',
      submit:'submit'
    })
  })
};

export function getAPIUrl(url, params = null) {
  const path = reverse(
    url.split('.').reduce((o, i) => o[i], endpoint),
    params
  );
  return getEnvValue('REACT_APP_API_URL') + path;
}

export const enterOnlyNumber = (event) => {
  const keyCode = event.which || event.keyCode;
  const keyValue = String.fromCharCode(keyCode);
  const isValid = new RegExp('[0-9]').test(keyValue);
  // const isValidecimal = new RegExp(".").test(keyValue);
  if (!isValid) {
    event.preventDefault();
    return;
  }
};


export const enterOnlyNumberWithdot = (event) => {
  const keyCode = event.which || event.keyCode;
  const keyValue = String.fromCharCode(keyCode);
  const isValid = new RegExp('[0-9.]').test(keyValue);
  // const isValidecimal = new RegExp(".").test(keyValue);
  if (!isValid) {
    event.preventDefault();
    return;
  }
};